module.exports = "/assets/data/d0836d93e77df5eaefde04df827ad305-NW9.data.json";